import React from 'react';
import { Container } from 'react-bootstrap';

import PageHeader from '../components/PageHeader';
import PortfolioTable from '../components/PortfolioTable';

import Helmet from 'react-helmet';
const pageTitle = 'Manage Portfolios';
export default function Portfolios() {
  return (
    <Container className='et-container'>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <PageHeader title={pageTitle} />

      <PortfolioTable />
    </Container>
  );
}
